/* global FB */
type LoginResponse = {
  token: string
}
export const login = () =>
  new Promise<LoginResponse>((resolve, reject) => {
    FB.login(
      (res) => {
        if (res.authResponse) {
          resolve({ token: res.authResponse.accessToken })
        } else {
          reject(res)
        }
      },
      { scope: 'email,user_location' }
    )
  })

// @types/facebook-js-sdk didn't like the 'location.fields(location)' field
// so it thinks res is unknown
// So we have to manually type the response
type UserDetailsSuccessResponse = {
  last_name: 'string'
  email: 'string'
  location: {
    location: {
      country: string
    }
  }
}

type UserDetailsErrorResponse = {
  error: any
}

type UserDetailsResponse = UserDetailsSuccessResponse & UserDetailsErrorResponse

export const getUserDetails = () =>
  new Promise<UserDetailsResponse>((resolve, reject) => {
    FB.api(
      '/me',
      {
        fields: [
          'first_name',
          'last_name',
          'email',
          'location.fields(location)',
        ],
      },
      (res: UserDetailsResponse) => {
        if (res && !res.error) {
          resolve(res)
        } else {
          reject(res)
        }
      }
    )
  })
